// *** ProfileBio Component ****
import React, { useEffect, useState, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import { API } from "../../services/api";
import ReactPlayer from 'react-player'


const PodCast = (props) => {
    const Group = require("../../assets/img/Featured icon.jpg");

    return (
        <div>

            <Modal
                show={props.isPodCastPlay}
                onHide={props.handleClose}
                dialogClassName="custom-video-modal custom-modal modal-dialog-centered"
                centered
                backdrop="static"
                keyboard={false}
            >
                <div className="video-wrapper position-relative">
                    <button
                        type="button"
                        className="btn-close position-absolute top-0 end-0 m-3 z-3"
                        onClick={props.handleClose}
                        aria-label="Close"
                    ></button>
                    
                    <div className="w-100 rounded">
                        <ReactPlayer url={props.podUrl}
                            controls={true}
                        />
                    </div>
                </div>
            </Modal>



        </div >
    );
};
export default PodCast;
